import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ServicecallService } from 'src/app/services/servicecall.service';

@Component({
  selector: 'app-history-playback',
  templateUrl: './history-playback.component.html',
  styleUrls: ['./history-playback.component.css']
})
export class HistoryPlaybackComponent implements OnInit {
  @Input() entityData: any;
  today: any = new Date();
  endTime: any;
  masterMapData: any = [];
  mileage: any = [];
  speed: any = [];
  fuel: any = [];
  constructor(private datePipe: DatePipe, private service: ServicecallService) { }

  ngOnInit(): void {
    this.getGeoHistory();
    this.getChartData();
  }

  getGeoHistory() {
    const requestData = {
      entityId: this.entityData?._id,
      from: this.datePipe.transform(new Date(this.today.setMinutes(this.today.getMinutes() - 15)), 'yyyy-MM-ddTHH:mm:ssZ'),
      to: this.datePipe.transform(this.endTime ? this.endTime : Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
    };
    this.service.locateEntity(requestData).subscribe((resp: any) => {
      if (resp?.status) {
        const enitityCords = resp.response.data[0].coordinates;
        this.masterMapData = [{
          polygonData: enitityCords.map(({ lat, long }) => { return [lat, long] })
        }];
      } else {
        this.masterMapData = [];
        if (resp?.response?.message)
          this.service.toasterService({ type: 'error', msg: resp?.response?.message });
      }
    });
  }

  getChartData() {
    if (this.entityData?.map) {
      this.mileage = [{
        x: this.entityData?.map[0].dataSet.map(({ date }) => date = new DatePipe('en-US').transform(date, 'yyyy-MM-dd')),
        y: this.entityData?.map[0].dataSet.map(({ value }) => value),
        mode: 'lines+markers',
        connectgaps: true,
        title: '',
        margin: {
          l: 30,
          r: 10,
          b: 30,
          t: 0
        }
      }];

      this.speed = [{
        x: this.entityData?.map[1].dataSet.map(({ date }) => date = new DatePipe('en-US').transform(date, 'yyyy-MM-dd')),
        y: this.entityData?.map[1].dataSet.map(({ value }) => value),
        mode: 'lines+markers',
        connectgaps: true,
        title: '',
        margin: {
          l: 30,
          r: 10,
          b: 30,
          t: 0
        }
      }];

      this.fuel = [{
        x: this.entityData?.map[2].dataSet.map(({ date }) => date = new DatePipe('en-US').transform(date, 'yyyy-MM-dd')),
        y: this.entityData?.map[2].dataSet.map(({ value }) => value),
        mode: 'lines+markers',
        connectgaps: true,
        title: '',
        margin: {
          l: 30,
          r: 10,
          b: 30,
          t: 0
        }
      }];
    }
    else {
      this.mileage = [];
      this.speed = [];
      this.fuel = [];
    }
  }

}
